import { type CellContext, createColumnHelper } from '@tanstack/react-table';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { AssetTagsWithDetailsModal } from 'components/AssetTags';

const useGetTagsTableColumn = ({
  createTableActions,
}: {
  createTableActions: (info: CellContext<any, any>) => ReactNode;
}): any => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<any>();

  const columns = [
    columnHelper.accessor('display_name', {
      header: () => t('assetsPage.TagsTab.columns.tagName'),
      cell: (info) => (
        <span className="min-w-[150px] block">{info.renderValue() ?? '-'}</span>
      ),
      enableSorting: true,
      size: 180,
    }),
    columnHelper.accessor('description', {
      header: () => t('assetsPage.TagsTab.columns.tagDescription'),
      cell: (info) => (
        <span className="min-w-[150px] block">{info.renderValue() ?? '-'}</span>
      ),
    }),
    columnHelper.accessor('assets', {
      header: () => t('assetsPage.TagsTab.columns.linkedBuildings'),
      cell: (info) => {
        const assets = info.getValue();
        const tagId = info.row.original.id; // Get the tag ID from the row data
        return (
          <div className="min-w-[200px]">
            <AssetTagsWithDetailsModal
              assets={assets}
              maxVisible={4}
              showEllipsis={false}
              tagId={tagId}
            />
          </div>
        );
      },
    }),
    columnHelper.accessor('', {
      enableSorting: false,
      id: 'action',
      cell: (info) => createTableActions(info),
      size: 15,
    }),
  ];

  return {
    columns,
  };
};
export default useGetTagsTableColumn;
